import { Outlet } from "react-router-dom";
import { Navbar } from "../../Components";

export function DefaultLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}
